module.exports = __webpack_public_path__ + "operace-previsleho-bricha-abdominoplastika_18_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-previsleho-bricha-abdominoplastika_18_before.jpg
// module id = 1192
// module chunks = 0